import { AfterViewInit, Component } from '@angular/core';
import { HorizontalMenuService } from 'src/app/services/horizontalmenu.service';
import CustomStore from 'devextreme/data/custom_store';
import { environment } from 'src/environments/environment';
import { CrudService } from 'src/app/services/crud.service';
import { NotifyService } from 'src/app/services/notify.service';
import { DxDataGridModule, DxLoadPanelModule } from 'devextreme-angular';
import { JoyrideModule } from 'ngx-joyride';
import { JourneyService } from 'src/app/services/journey.service';
import { PageHeaderComponent } from 'src/app/shared/page-header/page-header.component';

@Component({
    selector: 'app-warehouse',
    templateUrl: './warehouse.component.html',
    styleUrls: ['./warehouse.component.css'],
    imports: [ DxDataGridModule, DxLoadPanelModule, JoyrideModule, PageHeaderComponent ],
    standalone: true
})
export class WarehouseComponent implements AfterViewInit {
  editWarehouse: boolean = false;
  dataSource: CustomStore;
  loading: boolean = false;
  private apiUrl: string = environment.baseApiUrl;
  constructor(private horizontalMenuService:HorizontalMenuService,
              private crudService: CrudService,
              private notifyService: NotifyService,
              private journeyService: JourneyService) {
    this.horizontalMenuService.editWarehouse$.subscribe((value) => {
      this.editWarehouse = value;
      this.loading = true;
      this.dataSource = new CustomStore<any>({
        load: async () => {
          this.loading = true;
          return await new Promise((resolve) => {
            this.crudService.getData(`${this.apiUrl}warehouses`).subscribe((result: any) => {
              this.loading = false;
              resolve({data: result, totalCount: result.length});
            })
          })
        },
        insert: async (values) => {
          this.loading = true;
          return await new Promise(async (resolve) => {
            await this.crudService.insertData(`${this.apiUrl}warehouses`, values)
            .subscribe((result: any) => {
              this.loading = false;
              this.notifyService.tellUser(result);
              resolve(result);
            });
          });
        },
        update: async (key, values) => {
          this.loading = true;
          console.log(key, values);
          return await new Promise(async (resolve) => {
            await this.crudService.updateData(`${this.apiUrl}warehouses`, key.id, values)
            .subscribe((result: any) => {
              this.loading = false;
              this.notifyService.tellUser(result);
              resolve(result);
            });
          });
        },
        remove: async (key) => {
          this.loading = true;
          return await new Promise(async (resolve) => {
            await this.crudService.deleteData(`${this.apiUrl}warehouses`, key.id)
            .subscribe((result: any) => {
              this.loading = false;
              this.notifyService.tellUser(result);
              resolve(result);
            });
          });
        }
      })
    });
  }

  ngAfterViewInit(): void {
    this.journeyService.tryStartPhase('settings-warehouses');
  }
}
